module.exports = __webpack_public_path__ + "img/44ee161ff4c8e8bc7c0695c7ad3d3668.png";